import * as Yup from "yup";

export const validationSchemaCreateVehicleDocument = Yup.object().shape({
  cardNumber: Yup.string().required("Required field"),
  policeNumber: Yup.string().required("Required field"),
  cost: Yup.string().required("Required field"),
  // Periodicity options are objects {label, value} — transform before validating
  periodicity: Yup.string()
    .transform((curr, orig) => (orig && typeof orig === "object" ? orig.value : curr))
    .required("Required field"),
});

interface FormValuesVehicleDocument {
  cardNumber: string;
  policeNumber: string;
  cost: string;
  periodicity: string;
}

export const initialValuesVehicleDocument: FormValuesVehicleDocument = {
  cardNumber: "",
  policeNumber: "",
  cost: "",
  periodicity: "",
};
